import { useState}  from "react";
import {Donut} from "./Donut";

const COLUMNS = ['cemi', 'cemiia', 'ggbs', 'coarse_agg', 'fine_agg', 'water', 'admixture'];
export function ClimaKrete(props) {
  const [ matrix, setMatrix ] = useState(window.climakreteData.matrix);
  const [ baseType, setBaseType ] = useState(window.climakreteData.baseType);
  const [ mode , setMode ] = useState(props.args.mode ? props.args.mode : 'auto'); // simple or detailed
  const [ showResults , setShowResults ] = useState(false);
  const [ selected, setSelected ] = useState({
    grade: '',
    slump: '',
    type: ''
  });
  const [ volume, setVolume ] = useState(1); // default volume in m3  
  
  function conditionallyShowResults(slug) {
    if (!slug) {
      setShowResults(false);
    } else if (mode === 'auto') {
      setShowResults(true);
    }
  }
  
  function selectGrade(slug) {
    setShowResults(false);
    let slump = '';
    let type = '';
    
    // if selected grade has existing slump and type keep them selected, else reset
    if (slug) {
      slump = matrix[slug].slumps[selected.slump] ? selected.slump : '';
      
      if (slump) {
        type = slump && matrix[slug].slumps[slump].types[selected.type] ? selected.type : '';
      }
    }

    conditionallyShowResults(type);    
    
    setSelected({...selected, grade: slug, slump: slump, type: type});
    
  }  
  function selectSlump(slug) {
    setShowResults(false);
    let type = '';
    // if selected slump has existing type keep it selected, else reset
    if (slug) {
      type = matrix[selected.grade].slumps[slug].types[selected.type] ? selected.type : '';
    }

    conditionallyShowResults(type);
    
    setSelected({...selected, slump: slug, type: type});
  }
  
  function selectType(slug) {
    setShowResults(false);
    setSelected({...selected, type: slug});

    conditionallyShowResults(slug);
  }
  
  function updateInput(value) {
    if (!value || mode !== 'auto') {
      setShowResults(false);
    }
    setVolume(value);
  }
  
  function EmissionsReduction(emissions, baseEmissions) {    
    return baseEmissions > 0 ? (((baseEmissions - emissions) / baseEmissions) * 100).toFixed(0) : '0';
  }
  
  
  return (
    <div className="climakrete-calculator">
      <h2>ClimaKrete Carbon Calculator</h2>
      <div className={"wrapper"}>
        <table className={'filters'}>
          <tbody>
          <tr className="filter-item">
            <td>Grade:</td>
            <td>
              <select className={"filter-grade"} value={selected.grade} onChange={(e) => selectGrade(e.target.value)}>
                <option value="">Select Grade</option>
                {Object.keys(matrix).map((gradeKey) => (
                  <option key={gradeKey} value={gradeKey}>{matrix[gradeKey].name}</option>
                ))}
              </select>
            </td>
          </tr>

          <tr className="filter-item">
            <td>Slump:</td>
            <td>
              <select className={"filter-slump"} value={selected.slump} disabled={!selected.grade}
                      onChange={(e) => selectSlump(e.target.value)}>
                <option value="">Select Slump</option>
                {selected.grade && Object.keys(matrix[selected.grade].slumps).map((slumpKey) => (
                  <option key={slumpKey} value={slumpKey}>{matrix[selected.grade].slumps[slumpKey].name}</option>
                ))}
              </select>
            </td>
          </tr>

          <tr className="filter-item">
            <td>Type:</td>
            <td>
              <select className={"filter-type"} value={selected.type} disabled={!selected.slump}
                      onChange={(e) => selectType(e.target.value)}>
                <option value="">Select Type</option>
                {selected.grade && selected.slump && Object.keys(matrix[selected.grade].slumps[selected.slump].types).map((typeKey) => (
                  <option key={typeKey}
                          value={typeKey}>{matrix[selected.grade].slumps[selected.slump].types[typeKey].name}</option>
                ))}
              </select>
            </td>
          </tr>

          {/*  Product volume */}
          <tr className="filter-item">
            <td>Volume (m³):</td>
            <td>
              <input type="number" min="0" step="0.1" value={volume}
                     onChange={(e) => updateInput(parseFloat(e.target.value) || 0)}/>
            </td>
          </tr>

          {mode === 'submit' &&
            <tr className="filter-item">
              <td></td>
              <td>
                <button className="calculate-button btn" onClick={() => setShowResults(true)} disabled={!selected.type}>Calculate</button> 
              </td>
            </tr>
          }
          </tbody>
        </table>
        
        {showResults &&
          <div className="results">
            <h4>Your results</h4>

            <div className={"wrapper"}>
              <div className={'donut'}>
                <Donut percentage={EmissionsReduction(
                  matrix[selected.grade].slumps[selected.slump].types[selected.type].values,
                  matrix[selected.grade].slumps[selected.slump].types[baseType].values
                )} size={150} stroke={15} color={"#4caf50"} bg={"#ddd"}/>
              </div>

              <table>
                <tbody>
                <tr>
                  <td>Carbon emissions per m<sup>3</sup>:</td>
                  <td>
                  <span
                    className={'emissions'}>{(matrix[selected.grade].slumps[selected.slump].types[selected.type].values).toFixed(0)}</span> (kg
                    CO₂e)/m3
                  </td>
                </tr>
                <tr>
                  <td>Total carbon emissions:</td>
                  <td>
                  <span className={'emissions'}>
                    {(matrix[selected.grade].slumps[selected.slump].types[selected.type].values * volume).toFixed(0)}
                  </span> kg CO₂e
                  </td>
                </tr>
                <tr>
                  <td>Total CO₂ reduction:</td>
                  <td>
                  <span className={'emissions'}>
                    {((matrix[selected.grade].slumps[selected.slump].types[baseType].values - matrix[selected.grade].slumps[selected.slump].types[selected.type].values) * volume).toFixed(0)}
                  </span> kg CO₂e
                  </td>
                </tr>
                <tr className={'disclaimer'}>
                  <td colSpan={2}>* Compared to CEMI mix:&nbsp; 
                  <b>{(matrix[selected.grade].slumps[selected.slump].types[baseType].values * volume).toFixed(0)}</b> kg
                    CO₂e
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

          </div>

        }
      </div>

    </div>
  );
}